import { render, staticRenderFns } from "./gross-price.vue?vue&type=template&id=dd3af028&"
import script from "./gross-price.vue?vue&type=script&lang=js&"
export * from "./gross-price.vue?vue&type=script&lang=js&"
import style0 from "./gross-price.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "gross-price.vue"
export default component.exports